import { TGuid } from '@core/helpers';

import { EGenderDTO, EProfileTypeDTO } from './_index';

export interface INurseDTO {
  id: string;
  first_name: string;
  last_name: string;
  age: number;
  date_of_birth: string;
  email: string;
  gender: EGenderDTO;
  phone: string;
  profile_type: EProfileTypeDTO.Nurse;
  user_id: string;
  photo_url: string | null;
  cpf_number: string | null;
  // Properties below are present but doesn't make sense for nurse
  address: null;
  doctor_status: null;
  father_patient_id: string | null;
  is_atypical_child_guardian: boolean | null;
  mothers_name: string | null;
  source: string | null;
  specialization: string | null;
  tags: null;
}

export interface INurse {
  id: TGuid;
  cpf: string | null;
  fullName: string | null;
  firstName: string;
  lastName: string;
  email: string | null;
  gender: EGenderDTO;
  birthDate: Date | null;
  photoUrl: string | null;
  phone: string;
  profileType: EProfileTypeDTO.Nurse;
}

export class NurseViewModelFactory {
  static createFromDTO(dto: INurseDTO): INurse {
    return {
      id: dto.id,
      cpf: dto.cpf_number,
      fullName: `${dto.first_name} ${dto.last_name}`,
      firstName: dto.first_name,
      lastName: dto.last_name,
      email: dto.email,
      birthDate: dto.date_of_birth ? new Date(dto.date_of_birth) : null,
      gender: dto.gender,
      phone: dto.phone,
      photoUrl: dto.photo_url,
      profileType: dto.profile_type,
    };
  }
}
